import { render, staticRenderFns } from "./report-upload.vue?vue&type=template&id=18408e72&"
import script from "./report-upload.vue?vue&type=script&lang=js&"
export * from "./report-upload.vue?vue&type=script&lang=js&"
import style0 from "./report-upload.vue?vue&type=style&index=0&id=18408e72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports